import styled from "styled-components";
import { AddCircle } from "@material-ui/icons";

const CustomAddCircle = styled(AddCircle)`
  &&& {
    color: ${({ theme }) => theme.palette.primary.main};
    position: absolute;
    bottom: 25%;
    right: 14%;
    height: 1.5rem;
    width: 1.5rem;
  }
`;

export default CustomAddCircle;
